import { useAdCampaignDetail } from 'data/ad-campaign';
import React from 'react';

import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import AdCampaignLeadsTable from 'components/AdCampaignLeadsTable';
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    fontWeight: 400,
  },
}));

type Props = {
  adCampaignId: string;
};

export default ({ adCampaignId }: Props) => {
  const classes = useStyles();

  const { adCampaign, isLoadingAdCampaign } = useAdCampaignDetail(adCampaignId);

  if (isLoadingAdCampaign) {
    return (
      <div className={classes.root}>
        <LoadingIndicator />
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <Grid container justifyContent="flex-start">
        <Grid item xs={12} style={{ marginTop: '20px' }}>
          <AdCampaignLeadsTable adCampaignId={adCampaign._id} />
        </Grid>
      </Grid>
    </div>
  );
};
